<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p3_shiraz-box">
  <!-- Artboard: xs -->
  <div
    id="g-p3_shiraz-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.0576923076923;"
  >
    <div
      id="g-p3_shiraz-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_shiraz-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:2.9106%;margin-top:-11.1px;left:0%;width:150px;"
    >
      <p class="g-pstyle0">Shiraz missile facility</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:23.8776%;margin-top:-7.5px;left:17.029%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:29.9673%;margin-top:-7.5px;left:15.7528%;width:54px;"
    >
      <p class="g-pstyle2">Shiraz</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:60.4801%;margin-top:-14.7px;left:63.2826%;margin-left:-56px;width:112px;"
    >
      <p class="g-pstyle3">Active fire</p>
      <p class="g-pstyle3">around the facility</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p3_shiraz-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.0828025477707;"
  >
    <div
      id="g-p3_shiraz-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_shiraz-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.9457%;margin-top:-11.2px;left:0%;width:168px;"
    >
      <p class="g-pstyle0">Shiraz missile facility</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:16.0293%;margin-top:-7.5px;left:11.3474%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:19.6387%;margin-top:-7.5px;left:10.5827%;width:54px;"
    >
      <p class="g-pstyle2">Shiraz</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:62.9508%;margin-top:-7.5px;left:63.2832%;margin-left:-82px;width:164px;"
    >
      <p class="g-pstyle3">Active fire around the facility</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p3_shiraz-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.08196721311476;"
  >
    <div
      id="g-p3_shiraz-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_shiraz-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:2.1852%;margin-top:-11.3px;left:0%;width:205px;"
    >
      <p class="g-pstyle0">Shiraz missile facility</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:15.751%;margin-top:-9.1px;left:11.3799%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:19.5215%;margin-top:-9.1px;left:10.5893%;width:59px;"
    >
      <p class="g-pstyle2">Shiraz</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:62.8002%;margin-top:-9.1px;left:63.4363%;margin-left:-94px;width:188px;"
    >
      <p class="g-pstyle3">Active fire around the facility</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-p3_shiraz-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.5;"
  >
    <div
      id="g-p3_shiraz-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_shiraz-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:40.3873%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:40.3873%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:40.3873%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
  </div>

  <!-- Artboard: xl -->
  <div
    id="g-p3_shiraz-xl"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.93548387096774;"
  >
    <div
      id="g-p3_shiraz-xl-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_shiraz-xl.jpg);"
    ></div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-18 18:15 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-18 18:15 -->
<!-- ai file: p3_shiraz.ai -->
<style lang="scss">
  #g-p3_shiraz-box,
  #g-p3_shiraz-box .g-artboard {
    margin: 0 auto;
  }
  #g-p3_shiraz-box p {
    margin: 0;
  }
  #g-p3_shiraz-box .g-aiAbs {
    position: absolute;
  }
  #g-p3_shiraz-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p3_shiraz-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p3_shiraz-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p3_shiraz-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p3_shiraz-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-p3_shiraz-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-p3_shiraz-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-p3_shiraz-xl {
        display: block !important;
      }
    }
  }
  #g-p3_shiraz-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p3_shiraz-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_shiraz-xs .g-pstyle0 {
    font-weight: 700;
    line-height: 21px;
    height: 21px;
    font-size: 14px;
    color: rgb(0, 0, 0);
  }
  #g-p3_shiraz-xs .g-pstyle1 {
    height: 14px;
    letter-spacing: 0.2em;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_shiraz-xs .g-pstyle2 {
    height: 14px;
    color: rgb(0, 0, 0);
  }
  #g-p3_shiraz-xs .g-pstyle3 {
    height: 14px;
    text-align: center;
  }
  #g-p3_shiraz-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p3_shiraz-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_shiraz-sm .g-pstyle0 {
    font-weight: 700;
    line-height: 21px;
    height: 21px;
    font-size: 16px;
    color: rgb(0, 0, 0);
  }
  #g-p3_shiraz-sm .g-pstyle1 {
    height: 14px;
    letter-spacing: 0.2em;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_shiraz-sm .g-pstyle2 {
    height: 14px;
    color: rgb(0, 0, 0);
  }
  #g-p3_shiraz-sm .g-pstyle3 {
    height: 14px;
    text-align: center;
  }
  #g-p3_shiraz-md {
    position: relative;
    overflow: hidden;
  }
  #g-p3_shiraz-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_shiraz-md .g-pstyle0 {
    font-weight: 700;
    line-height: 21px;
    height: 21px;
    font-size: 20px;
    color: rgb(0, 0, 0);
  }
  #g-p3_shiraz-md .g-pstyle1 {
    height: 17px;
    letter-spacing: 0.2em;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_shiraz-md .g-pstyle2 {
    height: 17px;
    color: rgb(0, 0, 0);
  }
  #g-p3_shiraz-md .g-pstyle3 {
    height: 17px;
    text-align: center;
  }
  #g-p3_shiraz-lg {
    position: relative;
    overflow: hidden;
  }
  #g-p3_shiraz-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_shiraz-lg .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-p3_shiraz-lg .g-pstyle1 {
    height: 18px;
    padding-bottom: 9px;
  }
  #g-p3_shiraz-lg .g-pstyle2 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }
  #g-p3_shiraz-xl {
    position: relative;
    overflow: hidden;
  }
  #g-p3_shiraz-xl p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_shiraz-xl .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-p3_shiraz-xl .g-pstyle1 {
    height: 18px;
    padding-bottom: 9px;
  }
  #g-p3_shiraz-xl .g-pstyle2 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
